const makeInitialState = () => ({
  holderName: '',
  cardNumber: '',
  expirationMonth: '',
  expirationYear: '',
  cvv: ''
});

export default makeInitialState;

